/**
 * Действует ли в партии бонус дохода «за каждый город» (configs/playerBonus,
 * с 29.10). До него доход бонуса был фиксированным, и уровни были другими.
 *
 * Записи матчей проигрываются через редьюсеры. Числа явных ботов и бонуса
 * лобби зафиксированы в самом игроке (bonusConfig) и проигрываются по себе. А у
 * локальных партий чисел в записи нет — они берутся из конфига по уровню, и
 * старая запись разошлась бы с сыгранным. Поэтому метку isPlayerBonusPerCityRule
 * ставит LOAD_STATE (см. loadState в redux/actions); у старых записей ее нет —
 * только у них она false, и createPlayersState кладет их игрокам прежние числа
 * (LEGACY_PLAYER_BONUS_CONFIG).
 *
 * @param {Object} [gameState] - состояние партии
 * @returns {boolean}
 */
export const checkIfPlayerBonusPerCityRule = (gameState) => gameState?.isPlayerBonusPerCityRule !== false;
